// src/components/store/sections/newsletter/NewsletterV95VipticketEmeraldMint.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV95VipticketEmeraldMint(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={95}
      archKey="vip_ticket"
      archLabel="VIP Coupon Ticket Box"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#10b981"
      {...props}
    />
  );
}
